/**
 * @generated SignedSource<<a671ff81430854a276a18607a108cf9c>>
 * @relayHash 130b6d8daf4ab9257530dc83f6e283d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a69f87184adef0cb8abf2613d85259c528a9082df95d260f4ca95135a1c821b4

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceShareableLinkAccessType = "EXTERNAL" | "INTERNAL_LICENSED" | "%future added value";
export type PublicLinkPageStatus = "BLOCKED_BY_CLASSIFICATION_LEVEL" | "BLOCKED_BY_CONTAINER_POLICY" | "BLOCKED_BY_ORG" | "BLOCKED_BY_ORG_DEFAULT_POLICY" | "BLOCKED_BY_PRODUCT" | "BLOCKED_BY_SPACE" | "OFF" | "ON" | "SITE_BLOCKED" | "SITE_DISABLED" | "SPACE_BLOCKED" | "SPACE_DISABLED" | "TRASHED" | "%future added value";
export type useAccessLinkPageDataProviderShareableLinkPageQuery$variables = {
  pageId: string;
};
export type useAccessLinkPageDataProviderShareableLinkPageQuery$data = {
  readonly publicLinkPage: {
    readonly accessType: ConfluenceShareableLinkAccessType | null | undefined;
    readonly pageId: string;
    readonly pageStatus: PublicLinkPageStatus;
    readonly publicLinkUrlPath: string | null | undefined;
  } | null | undefined;
};
export type useAccessLinkPageDataProviderShareableLinkPageQuery = {
  response: useAccessLinkPageDataProviderShareableLinkPageQuery$data;
  variables: useAccessLinkPageDataProviderShareableLinkPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
      }
    ],
    "concreteType": "PublicLinkPage",
    "kind": "LinkedField",
    "name": "publicLinkPage",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "pageId"
      },
      {
        "kind": "ScalarField",
        "name": "pageStatus"
      },
      {
        "kind": "ScalarField",
        "name": "publicLinkUrlPath"
      },
      {
        "kind": "ScalarField",
        "name": "accessType"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAccessLinkPageDataProviderShareableLinkPageQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAccessLinkPageDataProviderShareableLinkPageQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "130b6d8daf4ab9257530dc83f6e283d0",
    "id": "a69f87184adef0cb8abf2613d85259c528a9082df95d260f4ca95135a1c821b4",
    "metadata": {},
    "name": "useAccessLinkPageDataProviderShareableLinkPageQuery",
    "operationKind": "query",
    "text": "query useAccessLinkPageDataProviderShareableLinkPageQuery($pageId:ID!){publicLinkPage(pageId:$pageId){pageId,pageStatus,publicLinkUrlPath,accessType}}"
  }
};
})();

(node as any).hash = "7ff084136670a8efdb84662843c25947";

export default node;
